import { ProgressBar, Spinner, Button, Intent } from '@blueprintjs/core'
import { TEXT_LARGE } from '@blueprintjs/core/lib/esm/common/classes'
import { formatBytes } from '../../utils/fileUtils'

const UploadProgress = ({ 
  stage, 
  fileName, 
  progress, 
  uploadedBytes, 
  totalBytes,
  progressMessage,
  onCancel
}) => {
  if (stage === 'uploading') {
    return (
      <>
        <div style={{ marginBottom: '12px' }} className={TEXT_LARGE}>
          Uploading {fileName}
        </div>
        <div style={{ width: '100%', maxWidth: '500px', margin: '0 auto' }}>
          <ProgressBar 
            value={progress / 100} 
            intent="primary"
            stripes={false}
          />
          <div style={{ 
            marginTop: '12px', 
            textAlign: 'center',
            fontSize: '14px',
            color: '#5C7080'
          }}>
            <div style={{ marginBottom: '4px' }}>
              {progress}% complete
            </div>
            <div>
              {formatBytes(uploadedBytes)} / {formatBytes(totalBytes)}
            </div>
          </div>
        </div>
      </>
    )
  }
  
  if (stage === 'processing') {
    return (
      <>
        <div style={{ marginBottom: '12px' }} className={TEXT_LARGE}>
          Processing {fileName}
        </div>
        <div style={{ width: '100%', maxWidth: '500px', margin: '0 auto' }}>
          <ProgressBar 
            value={progress / 100}
            intent={progress === 100 ? Intent.SUCCESS : Intent.PRIMARY}
            stripes={progress < 100}
            animate={progress < 100}
          />
          <div style={{ 
            marginTop: '12px', 
            textAlign: 'center',
            fontSize: '14px',
            color: '#5C7080'
          }}>
            <div style={{ marginBottom: '8px' }}>
              {progress}% complete
            </div>
            {progressMessage && (
              <div style={{ marginBottom: '8px', fontStyle: 'italic' }}>
                {progressMessage}
              </div>
            )}
            {progress < 100 && <Spinner size={20} />}
            {onCancel && progress < 100 && (
              <div>
                <Button 
                  intent="danger" 
                  onClick={onCancel}
                  style={{ marginTop: '12px' }}
                  small
                >
                  Cancel Upload
                </Button>
              </div>
            )}
          </div>
        </div>
      </>
    )
  }
  
  // Fallback for other stages
  return (
    <>
      <div style={{ marginBottom: '12px' }} className={TEXT_LARGE}>
        Uploading {fileName}...
      </div>
      <Spinner />
    </>
  )
}

export default UploadProgress